import React from "react";
import ReactDOM from "react-dom/client";
import { Amplify } from "aws-amplify";
import "aws-amplify/auth/enable-oauth-listener";
import "./index.css";
import App from "./App";
import { buildAmplifyConfig, loadSettings } from "./amplifyConfig";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

loadSettings()
  .then((settings) => {
    Amplify.configure(buildAmplifyConfig(settings, window.location.origin));
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  })
  .catch(console.error);

reportWebVitals();
